var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloneEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55414 0.00390625L2.07227 2.48578H4.55414V0.00390625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9937 0H5.72598V3.65762H2.06836V17.0624H14.9937L14.9937 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1655 2.9375V18.2342H5.00586V20H17.9312V2.9375H16.1655Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H12",
    stroke: "#572148"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H12",
    stroke: "#572148"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H12",
    stroke: "#572148"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13V7",
    stroke: "#572148"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13V7",
    stroke: "#572148"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13V7",
    stroke: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneEventIcon);
export default __webpack_public_path__ + "static/media/clone-event-icon.b7d71df3bc35e5f7c4ee2d4d311c4e37.svg";
export { ForwardRef as ReactComponent };